import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";

const ButtonClose = styled("button")(() => ({
  marginLeft: "2rem",
  padding: 0,
  lineHeight: 1,
  outline: "none",
  border: "none",
  background: "transparent",
  color: "#C4CAD3",
  fontWeight: "200",
  ".icon": {
    transition: "all .3s ease-out",
  },
  "&:hover": {
    color: "#9EA3ACFF",
    ".icon": {
      transform: "rotate(180deg)",
    },
  },
}));

const DrawerHeader = ({ countActual, hideDrawer }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3, borderBottom: "1px solid #C4CAD3", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Typography fontFamily="Patua One" fontSize="26px">
        {t("header.drawer.title")}
      </Typography>

      <div>
        <span
          style={{
            background: "#F7F8F9",
            borderRadius: "4px",
            padding: "5px 10px",
            color: "#2287B8",
            fontFamily: "Patua One",
            fontWeight: "400",
            fontSize: "16px",
          }}
        >
          <AiOutlineShoppingCart style={{ marginRight: 10, color: "#2C3E50" }} />
          {countActual}
        </span>
        <ButtonClose onClick={hideDrawer}>
          <MdClose
            className="icon"
            style={{
              width: "32px",
              height: "32px",
            }}
          />
        </ButtonClose>
      </div>
    </Box>
  );
};

export default DrawerHeader;
